import React from 'react';
// import * as productImages from '../../img/product-images/*.png';
import * as brandImages from '../../img/product-brands/*.png';

// export const getProductImage = (product: string) => productImages[product];
export const getProductImage = (product: string) => product;
export const getBrandImage = (brand: string) => brandImages[brand];
